import React, { Suspense } from "react";
import PropTypes from "prop-types";

import { MapProvider } from "./context/MapContext";
import Loading from "../Loading";

const Map = React.lazy(() => import("./Map/Map"));
const Filterbar = React.lazy(() => import("./Filterbar/Filterbar"));

const App = ({ centre, isNewFood }) => {
	return (
		<MapProvider isNewFood={isNewFood}>
			<div className="map__container">
				<Suspense fallback={<Loading />}>
					<Filterbar />
					<Map centre={centre} isNewFood={isNewFood}/>
				</Suspense>
			</div>
		</MapProvider>
	);
};

App.propTypes = {
	centre: PropTypes.array,
	isNewFood: PropTypes.bool,
};

export default App;
